"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var data_1 = require("..");

var ChellChartEvent =
/** @class */
function () {
  function ChellChartEvent( // tslint:disable-next-line:no-reserved-keywords
  type, chartPiece, selectedPoints, plotlyEvent) {
    if (selectedPoints === void 0) {
      selectedPoints = [];
    }

    if (plotlyEvent === void 0) {
      plotlyEvent = {};
    }

    this.type = type;
    this.chartPiece = chartPiece;
    this.selectedPoints = selectedPoints;
    this.plotlyEvent = plotlyEvent;
  }

  ChellChartEvent.prototype.isAxis = function () {
    return this.chartPiece === data_1.CHELL_CHART_PIECE.AXIS;
  };

  return ChellChartEvent;
}();

exports.ChellChartEvent = ChellChartEvent;